import styled, { css } from 'styled-components'

const containerModifiers = {
  isDisabled: () => css`
    opacity: 0.5;
    cursor: not-allowed;

    * {
      cursor: not-allowed;
    }

    label {
      &:hover {
        color: inherit;
      }
    }
  `
}

export const Container = styled.div`
  ${({ theme, isDisabled }) => css`
    &.hide,
    input[type='checkbox'] {
      display: none;
    }

    /* Label */
    label {
      position: relative;
      margin-bottom: 0;

      display: flex;
      align-items: center;
      flex: auto;

      height: 100%;

      font-size: ${theme.font.sizes.small};

      transition: all ${theme.transition.default};
      cursor: pointer;

      color: var(--sl-fg-base);

      .checkbox-icon {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;

        width: var(--bulletWrapperSize);
        height: var(--bulletWrapperSize);
        border-radius: ${theme.border.radius.medium};
        border: var(--sl-border-base);
        background-color: ${theme.colors.white};
        margin-right: 0.5rem;

        &:focus-visible {
          box-shadow: var(--sl-focus-ring-base);
          border: var(--sl-border-base-strong-hover);
        }

        &:hover:not(.disabled) {
          border: var(--sl-border-base-strong-hover);
        }
      }

      .icon-check {
        display: none;
        color: ${theme.colors.white};
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }

      ${isDisabled && containerModifiers.isDisabled()}

      &.disabled {
        ${containerModifiers.isDisabled()}
      }
    }

    /* Input */
    input[type='checkbox']:checked,
    &.selected input[type='checkbox'] {
      + label .checkbox-icon {
        background-color: ${theme.colors.primary};
        border-color: ${theme.colors.primary};

        .icon-check {
          display: block;
        }

        &:focus-visible {
          background-color: color-mix(in srgb, var(--primary) 80%, black);
          box-shadow:
            0rem 0rem 0rem 0.0625rem var(--sl-color-gray-0),
            0rem 0rem 0rem 0.1875rem
              color-mix(in srgb, var(--primary) 40%, transparent);
        }

        &:hover:not(.disabled) {
          background-color: color-mix(in srgb, var(--primary) 80%, black);
          border: color-mix(in srgb, var(--primary) 80%, black);
        }
      }

      + label {
        span {
          color: ${theme.colors.dark};
        }
      }
    }

    .optional {
      display: inline;
      font-size: ${theme.font.sizes.xsmall};
      opacity: 0.5;
      margin-left: ${theme.spacings.tiny};
    }
  `}
`

export const HelperText = styled.p`
  ${({ theme }) => css`
    font-size: ${theme.font.sizes.xsmall};
    margin-top: ${theme.spacings.xxxsmall};
    margin-bottom: ${theme.spacings.xxxsmall};
  `}
`
